import {translate} from "../../../translate/translate";
import {Button, Grid, Typography} from "@mui/material";
import {Lock} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {URLS} from "../../../services/routes";

const AccessDeniedComponent = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-home">
            <div className="floating-title title-home">
                <Typography variant={"h5"}>{translate.t("permission_denied_title")}</Typography>
            </div>
            <div>
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    className="grid-container">
                    <Grid>
                        <Lock sx={{fontSize: 60}} color="disabled"/>
                    </Grid>
                    <Grid>
                        <Typography style={{paddingTop: "8px", paddingBottom: "16px"}} variant={"body1"}>
                            {translate.t("permission_denied_message")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Button variant="contained" color="secondary" onClick={() => navigate(URLS.HOME)}>
                            {translate.t("back_to_home").toUpperCase()}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default AccessDeniedComponent;
